import { DataType } from '@/util/index'
const LOAN_HISTORY = {
  section: {
    name: 'loan-history',
    caption: 'LOAN HISTORY'
  },
  sectionFields: [
    { label: '#', template: '{index}', fieldKey: 'index' },
    { label: 'DISBURSEMENT DATE', template: '{firstCreditDate}', fieldKey: 'firstCreditDate' },
    { label: 'STATUS', template: '{loanStatus}', fieldKey: 'loanStatus', options: { loanStatus: DataType.LoanStatus } },
    { label: 'SIGNED', template: 'checkIcon', fieldKey: 'signStatus' },
    { label: 'ADVANCE $', template: '{approvedAmount}', fieldKey: 'approvedAmount', format: 'currency' },
    { label: 'TRANSFERRED $', template: '{transferredAmount}', fieldKey: 'transferredAmount', format: 'currency' },
    { label: 'TOTAL $', template: '{totalAmount}', fieldKey: 'totalAmount', format: 'currency' },
    { label: 'PAID PAYMENT', template: '{paidAmount}', fieldKey: 'paidAmount', format: 'currency' },
    { label: 'UNPAID PRINCIPAL', template: '{leftPrincipal}', fieldKey: 'leftPrincipal', format: 'currency' }
  ]
}
export default LOAN_HISTORY
